/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:25/08/2022
 @Time:11:34
 **/

export default class SocieteUI
{


    static selectors=Object.freeze({
        "identifiantFiscalContainer":".identifiant-fiscal input"
    });


    /**
     * @type {SocieteUI}
     */
    static #_instance=null;


    constructor() {
        if(SocieteUI.#_instance===null)
        {
            SocieteUI.#_instance=this;
        }
        return SocieteUI.#_instance;
    }

    initWeb()
    {
          if($(".societe-form").length>0){
              Begro.logInfo("Le module société a détecté l'existance de son contexte et il sera fonctionnel")
              SocieteUI.attacherInputMaskToIdentifiantFiscal()
          }
    }


    static attacherInputMaskToIdentifiantFiscal()
    {
        $(SocieteUI.selectors.identifiantFiscalContainer).inputmask("999-a-a-*{7}/a");
    }
}